export type EmployeeType = {
  id: number;
  name: string;
  email: string;
};

export type EmployeesQueryVariablesType = {
  query: string;
  page: number;
  locationIDs: string[];
  sort: string;
  limit: number;
};

export type EmployeesQueryType = {
  __typename?: 'Query';
  employees: EmployeeType[];
};
